import PestPillarLayout from "./PestPillarLayout";

const PROBLEMS = [
  {
    title: "Gel appâts",
    desc: "Déposé en fines gouttes dans les fissures et zones de passage, le gel est consommé par les blattes qui le ramènent au nid. Méthode discrète, sans odeur, adaptée aux cuisines.",
  },
  {
    title: "Pulvérisation ciblée",
    desc: "Application localisée d'un insecticide homologué sur les refuges difficiles d'accès (plinthes, gaines, arrière des meubles), en complément du gel lorsque l'infestation l'exige.",
  },
  {
    title: "Particuliers et professionnels",
    desc: "Maisons, appartements, gîtes, chambres d'hôtes, restaurants et commerces alimentaires : le protocole est adapté au lieu, à son activité et à ses contraintes d'hygiène.",
  },
];

const METHOD = [
  { title: "Inspection", desc: "Repérage des zones infestées, identification de l'espèce et évaluation du niveau d'infestation, pièce par pièce." },
  { title: "Préparation", desc: "Nous vous indiquons comment préparer les lieux : vider les placards, protéger la vaisselle et les aliments, dégager l'accès aux zones techniques." },
  { title: "Traitement", desc: "Application du gel appâts dans les points stratégiques et, si nécessaire, pulvérisation ciblée sur les refuges identifiés." },
  { title: "Contrôle", desc: "Passage de contrôle pour vérifier l'efficacité et renouveler l'application si besoin, avec des conseils pour limiter tout retour." },
];

const FAQ = [
  {
    q: "Le traitement contre les cafards est-il visible ou malodorant ?",
    a: "Le gel appâts est appliqué en petites gouttes dans des endroits peu visibles et ne dégage pas d'odeur gênante. La pulvérisation, lorsqu'elle est nécessaire, reste localisée et nous vous indiquons le temps d'aération à respecter.",
  },
  {
    q: "Combien de temps faut-il pour se débarrasser des blattes ?",
    a: "Les premiers effets du gel apparaissent généralement en quelques jours, mais l'élimination complète d'une colonie demande plus de temps, car les œufs éclosent par vagues. C'est pourquoi un passage de contrôle est prévu. La durée dépend du niveau d'infestation.",
  },
  {
    q: "Puis-je rester chez moi pendant le traitement ?",
    a: "Avec le gel appâts seul, oui. En cas de pulvérisation, il faut quitter temporairement les pièces traitées et les aérer avant d'y revenir. Les consignes précises vous sont données avant l'intervention.",
  },
  {
    q: "Comment éviter le retour des cafards ?",
    a: "Ne laissez ni nourriture ni vaisselle sale à l'air libre, videz les poubelles régulièrement, réparez les fuites d'eau et rebouchez les fissures autour des canalisations. Évitez les insecticides en bombe pendant le traitement : ils peuvent réduire l'efficacité du gel.",
  },
];

const CITIES = ["Guéret", "La Souterraine", "Aubusson", "Bourganeuf", "Boussac", "La Celle-Dunoise"];

const RELATED = [
  { title: "Punaises de lit : reconnaître, traiter et éviter la récidive", slug: "punaises-de-lit-reconnaitre-traiter-eviter" },
  { title: "Dératisation en Creuse : quand faire appel à un professionnel ?", slug: "deratisation-creuse-quand-faire-appel-professionnel" },
];

export default function CafardsBlattesCreuse() {
  return (
    <PestPillarLayout
      slug="cafards-blattes-creuse"
      seoTitle="Cafards et blattes Creuse (23) — Traitement | K'REUSE"
      seoDescription="Traitement des cafards et blattes en Creuse (23) : gel appâts et pulvérisation ciblée par un technicien certifié Certibiocide. Devis gratuit."
      breadcrumbLabel="Cafards et blattes Creuse"
      heroBadge="Gel appâts · Pulvérisation · Certibiocide"
      heroTitleHtml={`Traitement cafards et blattes en <span class="font-medium text-[#1B5E20]">Creuse (23)</span>`}
      heroSubtitle="Cuisine, salle de bain, restaurant, gîte : nous éliminons les cafards et les blattes avec un traitement adapté, combinant gel appâts et pulvérisation ciblée."
      hero_h2="Un traitement professionnel, discret et ciblé"
      introParagraphs={[
        "Les cafards, aussi appelés blattes, apprécient la chaleur, l'humidité et les restes alimentaires. On les trouve surtout derrière l'électroménager, sous les éviers, dans les gaines techniques et les recoins des cuisines. Actifs la nuit, ils se cachent le jour : lorsqu'on en aperçoit en pleine journée, la population est souvent déjà bien installée.",
        "Leur présence pose un problème d'hygiène : ils peuvent souiller les aliments et les surfaces, et leurs déjections peuvent provoquer des allergies. Les bombes insecticides du commerce dispersent souvent les insectes vers d'autres pièces sans atteindre les nids, ce qui complique ensuite le traitement.",
        "Technicien certifié Certibiocide, K'REUSE EXTÉRIEUR identifie l'espèce présente (blatte germanique, orientale ou américaine), localise les zones de refuge et applique un traitement adapté : gel appâts au plus près des nids, complété si besoin par une pulvérisation ciblée de produits homologués. Nous intervenons chez les particuliers comme chez les professionnels.",
      ]}
      problems={PROBLEMS}
      method={METHOD}
      cities={CITIES}
      faq={FAQ}
      relatedArticles={RELATED}
      ctaTitle="Des cafards dans votre cuisine ? On s'en occupe."
      whatsappText="Bonjour, je souhaite un devis pour un traitement cafards / blattes en Creuse."
      withQuoteForm
      quoteServiceIndex={9}
      quoteIntro="Cafards en cuisine ou dans votre établissement ? Indiquez-nous les pièces concernées : nous vous recontactons pour l'inspection et un devis gratuit."
    />
  );
}
